export default __webpack_public_path__ + "static/media/IconDesc_DarkMatter.256.417b4d56.png";